export default __webpack_public_path__ + "static/media/delete.7e2a977d.svg";